import * as React from 'react'
import info from '../info.json'
import { Link, navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { IconShoppingBag, IconBook, IconInfoSmall} from '@tabler/icons-react'
import Form from './form'


export default function Footer(props){

    const buttonRef = React.useRef(null);


    function Toggle(){
        props.setVisible((prevState)=>!prevState)
    }
    function ToggleInfo(){
        props.setVisibleInfo((prevState)=>!prevState)
    }


    const handleClick = () => {
        if (buttonRef.current) {
            buttonRef.current.click();
        }
    };
    function click(e) {
        e.stopPropagation(); // Stop event propagation here
        handleClick();
    }

    return(
        <footer className='absolute bottom-0 z-20 w-full px-2 md:px-8 py-6 flex flex-col justify-end items-center'>
            <div className="slider-controler">
                <div className="swiper-pagination">                             
                </div>
            </div>
            
            <div className='flex flex-row justify-between items-end px-2 w-full md:px-[20px] max-h-[70px] lg:max-h-[200px]'>
                <nav className='md:flex-1 flex flex-row gap-4 items-end'>
                    <div className='flex flex-col'>
                        <span className='uppercase text-2xs md:text-sm'>Made in Ecuador</span>
                        <span className='uppercase font-bold text-xs md:text-base'>{props.collection}</span>
                    </div>
                    <span className='font-caslon text-5xl ml-20 hidden md:block -mb-2'>
                        {`${props.currentSlide<10?'0':''}${props.currentSlide}/${props.sliderLength<10?'0':''}${props.sliderLength}`}
                        </span>
                </nav>
{/* 
                <div className="slider-controler hidden xl:block">
                    <div className="swiper-pagination" id='slider-pagination'>                             
                    </div>
                </div> */}
                <nav className='flex-1 flex flex-row gap-2 md:gap-4 justify-end items-end max-h-[100px] pb-[2px] h-[50px]'>
                    <a href={props.catalog} ref={buttonRef} onTouchEnd={(e)=>click(e)} target="_blank" className='flex items-center px-2 md:px-6 h-full border uppercase hover:bg-charcoal hover:text-cream transition-all duration-200 ease-in-out text-xs md:text-sm lg:text-base cursor-pointer'>SEE CATALOG</a>
                    {props.boolInfo && <a onClick={ToggleInfo} onTouchEnd={ToggleInfo} className='flex items-center justify-center w-[3rem] aspect-square h-full border uppercase hover:bg-charcoal hover:text-cream transition-all duration-200 ease-in-out text-xs md:text-sm lg:text-base cursor-pointer rounded-full'><span className='font-caslon lowercase text-3xl pt-[2px] '>i</span> </a>}
                    {/* <button onClick={Toggle} onTouchEnd={Toggle} className='px-2 md:px-6 h-full border uppercase hover:bg-charcoal hover:text-cream transition-all duration-200 ease-in-out text-xs md:text-sm lg:text-base cursor-pointer'>Wholesale info request</button> */}
                </nav>
            </div>
    
        </footer>
    )

}
